export class HTTPError extends Error {
  code: number;

  constructor(statusCode: number, message: string) {
    super(message);
    this.name = 'HTTPError';
    this.code = statusCode;
  }
}
export class ServiceOffline extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'ServiceOffline';
  }
}
export class AuthNotLoggedIn extends Error {}
export class GoogleMissingScopes extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'GoogleMissingScopes';
  }
}
export class GooglePermissionDenied extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'GooglePermissionDenied';
  }
}
export class GoogleInvalidArgument extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'GoogleInvalidArgument';
  }
}
export class ClientPopupBlockerEnabled extends Error {}

export class GoogleFileNotFound extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'GoogleFileNotFound';
  }
}

export class GoogleAPIError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'GoogleAPIError';
  }
}

export class DataValidation extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'DataValidation';
  }
}

export class NotYetImplemented extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'NotYetImplemented';
  }
}

export default {
  HTTPError,
  ServiceOffline,
  AuthNotLoggedIn,
  GoogleMissingScopes,
  GooglePermissionDenied,
  GoogleInvalidArgument,
  GoogleAPIError,
  ClientPopupBlockerEnabled,
  GoogleFileNotFound,
  DataValidation,
  NotYetImplemented,
};
